import { Header } from './components/Header';
import './styles/scss/app.scss';

/* Component header contains all routes and components which routing points at */
function App() {
	return (
		<>
			<Header />
		</>
	);
}

export default App;
